import {
  Box,
  Typography,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';

export function EnqueueHumanNodeFields({ localNodeData, updateNodeData }) {
  return (
    <>
      <Box sx={{ mt: 2 }}>
        <Typography variant="body2" sx={{ fontWeight: 500, mb: 1 }}>
          Notas para el agente
        </Typography>
        <TextField
          value={localNodeData.notes || ''}
          size="small"
          fullWidth
          multiline
          rows={3}
          placeholder="Ej: Cliente solicita hablar con un asesor. Motivo: {{motivo}}"
          onChange={(e) => updateNodeData('notes', e.target.value)}
        />
      </Box>

      <Box sx={{ mt: 2 }}>
        <FormControl fullWidth size="small">
          <InputLabel id="enqueue-priority-label">Prioridad</InputLabel>
          <Select
            labelId="enqueue-priority-label"
            label="Prioridad"
            value={localNodeData.priority || 'normal'}
            onChange={(e) => updateNodeData('priority', e.target.value)}
          >
            <MenuItem value="low">Baja</MenuItem>
            <MenuItem value="normal">Normal</MenuItem>
            <MenuItem value="high">Alta</MenuItem>
          </Select>
        </FormControl>
      </Box>
    </>
  );
}
